import Domain from "./domain";
export default {
  methods: {
    getSupportRequests: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "support/details",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    updateSupportRequest: async function(object) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "support",
          object,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
